import { Component, Element, Event, h, Host, Listen, Prop } from '@stencil/core';
export class Panel {
  constructor() {
    this.accent = false;
    this.alert = false;
    this.centeredContent = false;
    this.closeable = false;
    this.elevated = false;
    this.fading = false;
    this.flat = false;
    this.info = false;
    this.inline = false;
    this.interactive = false;
    this.primary = false;
    this.tabbedIndex = '0';
    this.version = '4.1.9';
  }
  handleKeyDown(ev) {
    // if enter or spacebar is pressed on this element, we delegate it to click
    if (ev.code && (ev.code === 'Enter' || ev.code === 'Space')) {
      this.el.click();
    }
  }
  render() {
    return (h(Host, Object.assign({ class: "c-panel" }, Object.assign({}, (this.interactive ? { tabindex: this.tabbedIndex } : {}))),
      this.closeable && (h("c-button", { class: "c-panel__button", minimal: true, big: true, onClick: (ev) => this.close.emit(ev) },
        h("c-icon", { class: "c-panel__icon", name: "close" }))),
      h("slot", null, "Replaced content")));
  }
  static get is() { return "c-panel"; }
  static get originalStyleUrls() { return {
    "$": ["c-panel.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["c-panel.css"]
  }; }
  static get properties() { return {
    "accent": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "accent",
      "reflect": true,
      "defaultValue": "false"
    },
    "alert": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "alert",
      "reflect": true,
      "defaultValue": "false"
    },
    "attached": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "'left' | 'right' | 'top' | 'bottom' | 'horizontal' | 'vertical'",
        "resolved": "\"bottom\" | \"horizontal\" | \"left\" | \"right\" | \"top\" | \"vertical\"",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "attached",
      "reflect": true
    },
    "centeredContent": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "centered-content",
      "reflect": true,
      "defaultValue": "false"
    },
    "closeable": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "closeable",
      "reflect": true,
      "defaultValue": "false"
    },
    "elevated": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "elevated",
      "reflect": true,
      "defaultValue": "false"
    },
    "fading": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "fading",
      "reflect": true,
      "defaultValue": "false"
    },
    "flat": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "flat",
      "reflect": true,
      "defaultValue": "false"
    },
    "info": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "info",
      "reflect": true,
      "defaultValue": "false"
    },
    "inline": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "inline",
      "reflect": true,
      "defaultValue": "false"
    },
    "interactive": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "interactive",
      "reflect": true,
      "defaultValue": "false"
    },
    "legend": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "'string'",
        "resolved": "\"string\"",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "legend",
      "reflect": true
    },
    "primary": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "primary",
      "reflect": true,
      "defaultValue": "false"
    },
    "tabbedIndex": {
      "type": "string",
      "mutable": true,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "tabbed-index",
      "reflect": false,
      "defaultValue": "'0'"
    },
    "version": {
      "type": "string",
      "mutable": true,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "version",
      "reflect": true,
      "defaultValue": "'4.1.9'"
    }
  }; }
  static get events() { return [{
      "method": "close",
      "name": "close",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      }
    }]; }
  static get elementRef() { return "el"; }
  static get listeners() { return [{
      "name": "keydown",
      "method": "handleKeyDown",
      "target": undefined,
      "capture": false,
      "passive": false
    }]; }
}
